import {createRouter, createWebHistory} from 'vue-router'
import store from "@/store";
import Dashboard from "@/components/Dashboard";
import PathNotFound from "@/components/PathNotFound";
import Login from "@/components/Authentication/login";
import passwordForgotten from "@/components/Authentication/passwordForgotten";
import ResetPassword from "@/components/Authentication/ResetPassword";
import CorporateRegister from "@/components/Authentication/corporateRegister";

// 1. Define route components.
// These can be imported from other files
// App

// 2. Define some routes
// Each route should map to a component.
// We'll talk about nested routes later.
const routes = [
    {
        path: '/',
        name: 'main',
        component: Dashboard,
        meta: {requiresAuth: true},
    },
    {
        path: '/register',
        name: "corporate-register",
        component: CorporateRegister,
        meta: { guest: true },
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {guest: true},
    },
    {
        path: '/forgot-password/:email?',
        name: 'forgot-password',
        component: passwordForgotten,
        meta: {guest: true},
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password',
        component: ResetPassword,
        meta: {guest: true},
    },
    {
        path: "/:pathMatch(.*)*",
        component: PathNotFound,
        meta: {guest: true},
    }
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHistory(),
    routes, // short for `routes: routes`
})


router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isAuthenticated) {
            next();
            return;
        }
        next('/login');
    } else {
        next();
    }
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.guest)) {
        if (store.getters.isAuthenticated) {
            next("/");
            return;
        }
        next();
    } else {
        next();
    }
});

// 5. Create and mount the root instance.
export default router;